"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignParagraphs = void 0;
var getVerticalOffset = function (input) {
    var lineCount = input.paragraphs.reduce(function (acc, paragraph) { return acc + paragraph.length; }, 0);
    var textHeight = lineCount * input.lineHeight;
    switch (input.verticalAlignment) {
        case 'TOP':
            return 0;
        case 'MIDDLE':
            return (input.height - textHeight) / 2;
        case 'BOTTOM':
            return input.height - textHeight;
    }
};
var getHorizontalOffset = function (input) {
    switch (input.horizontalAlignment) {
        case 'CENTER':
            return (input.width - input.line.width) / 2;
        case 'RIGHT':
            return input.width - input.line.width;
    }
    return 0;
};
var justifyLine = function (input) {
    var words = input.text.split(' ').map(function (text) { return ({
        text: text,
        width: input.measureTextWidth(text),
    }); });
    if (words.length === 1) {
        return [
            {
                x: 0,
                y: input.y,
                text: words[0].text,
                width: words[0].width,
            },
        ];
    }
    var totalWordWidth = words.reduce(function (acc, _a) {
        var width = _a.width;
        return acc + width;
    }, 0);
    var spaceBetweenWords = (input.width - totalWordWidth) / (words.length - 1);
    var fragments = words.reduce(function (acc, word) {
        acc.fragments.push({
            x: acc.offsetX,
            y: input.y,
            width: word.width,
            text: word.text,
        });
        acc.offsetX += word.width + spaceBetweenWords;
        return acc;
    }, { offsetX: 0, fragments: [] }).fragments;
    return fragments;
};
var alignParagraphs = function (input) {
    var verticalOffset = getVerticalOffset(input);
    var fragments = input.paragraphs.reduce(function (accParagraph, paragraph) {
        var lineFragments = paragraph.reduce(function (accLine, line, lineIndex) {
            var horizontalOffset = getHorizontalOffset({
                horizontalAlignment: input.horizontalAlignment,
                width: input.width,
                line: line,
            });
            var y = (lineIndex + accParagraph.lineOffset) * input.lineHeight +
                verticalOffset;
            var isLastLineInParagraph = lineIndex === paragraph.length - 1;
            if (input.horizontalAlignment === 'JUSTIFY' &&
                !isLastLineInParagraph) {
                accLine.push.apply(accLine, __spreadArray([], __read(justifyLine({
                    y: y,
                    text: line.text,
                    width: input.width,
                    measureTextWidth: input.measureTextWidth,
                })), false));
            }
            else {
                accLine.push({
                    x: horizontalOffset,
                    y: y,
                    text: line.text,
                    width: line.width,
                });
            }
            return accLine;
        }, []);
        return {
            fragments: __spreadArray(__spreadArray([], __read(accParagraph.fragments), false), __read(lineFragments), false),
            lineOffset: accParagraph.lineOffset + paragraph.length,
        };
    }, { fragments: [], lineOffset: 0 }).fragments;
    return fragments;
};
exports.alignParagraphs = alignParagraphs;
